<template>
	<h2>Métodos de envío</h2>
	<p class="text-general text-padding-left">
		Elige el método de envío que prefieras
	</p>
	<div class="info-box-lg" v-if="render_show_fedex && !render_address.is_metroZone">
		<div class="custom-checkbox">
	        <input type="radio" v-model="shipping" value="1" id="cb-ship-1">
	        <label for="cb-ship-1"><img class="img-responsive" src="../../images/fedex.png" alt="fedex"></label>
	        <span v-if="render_fedex_quote && render_address.id" class="pull-right ship-pricing">
	        	<span v-show="shopping_cart.total <= to_be_free">${{ accounting.formatMoney(parseFloat(render_fedex_quote).toFixed(2), '') }}</span>
	        	<span v-show="shopping_cart.total > to_be_free">Sin costo</span>
	        </span>
	        <span v-if="!render_fedex_quote && render_address.id" class="pull-right ship-pricing"><loader></loader></span>
	        <span v-if="!render_fedex_quote && !render_address.id" class="ship-pricing">Agrega o elije una dirección para calcular costos de envío.</span>
  		</div>
		<p class="text-general padding-side-left-md">Recibe tu pedido con FedEx de 3 a 5 días hábiles a todo México. (El costo de este servicio se adicionará al total de tu pedido).<br><br>
		*No aplica para todos nuestros productos.
		</p>
	</div>
	<div class="info-box-lg" v-if="!render_address.is_metroZone">
		<div class="custom-checkbox">
	        <input type="radio" v-model="shipping" value="2" id="cb-ship-2">
	        <label class="info-box-title" for="cb-ship-2">Paquetería (por cobrar)</label>
	        <span v-if="render_national_quote != null && render_address.id" class="pull-right ship-pricing">
	        	<span v-show="shopping_cart.total <= to_be_free">${{ accounting.formatMoney(parseFloat(render_national_quote).toFixed(2), '') }}</span>
	        	<span v-show="shopping_cart.total > to_be_free">Sin costo</span>
	        </span>
	        <span v-if="render_national_quote == null && render_address.id" class="pull-right ship-pricing"><loader></loader></span>
	        <span v-if="!render_national_quote && !render_address.id" class="ship-pricing">Agrega o elije una dirección para calcular costos de envío.</span>
	        <!-- <span class="pull-right ship-pricing">Por cobrar</span> -->
  		</div>
		<p class="text-general padding-side-left-md">
		Contamos con una red de paqueterías para surtir a todo México.<br>
		Este servicio se realiza POR COBRAR.<br>
		Te notificaremos el valor final a pagar una vez que se envíe tu pedido.<br>
		El costo que se menciona a continuación es Aproximado.
		</p>
	</div>
	<div class="info-box-lg">
		<div class="custom-checkbox">
	        <input type="radio" v-model="shipping" value="3" id="cb-ship-3">
	        <label class="info-box-title" for="cb-ship-3">Recolección en Showroom</label>
	        <span class="ship-pricing">Sin Costo</span>
  		</div>
		<p class="text-general padding-side-left-md">
		Puedes pasar a recoger tu pedido por nuestro Showroom ubicado en la Colonia Americana, en Guadalajara.<br>
		Esta opción no tiene costo adicional. 
		Nos contactaremos contigo para programar la fecha de la recolección.
		</p>
	</div>
	<div class="info-box-lg" v-if="render_address.is_metroZone">
		<div class="custom-checkbox">
	        <input type="radio" v-model="shipping" value="4" id="cb-ship-4">
	        <label class="info-box-title" for="cb-ship-4">Entrega a domicilio</label>
	        <span class="ship-pricing">Sin Costo</span>
  		</div>
		<p class="text-general padding-side-left-md">
		Tu domicilio se encuentra ubicado en la Zona Metropolitana de Guadalajara.<br>
		Si seleccionas esta opción la entrega de tu pedido es GRATIS en el domicilio que completaste en el paso anterior.
		</p>
	</div>
	<div v-if="has_error" class="error">{{ error_msg }}</div>
	<div class="col-sm-offset-9 col-sm-3 no-padding-sides"><br>
		<button type="submit" class="btn btn-black btn-lg" @click="nextStep">Continuar</button>
	</div>
</template>

<script>
import { setShippingShoppingCart } from '../../store/actions';
import Loader from '../Loader.vue';
import accounting from '../../scripts/accounting';

export default {
	data() {
		return {
			shipping: 0,
			has_error: false,
			error_msg: null,
			to_be_free: 15000,
			accounting,
		};
	},

	vuex: {
		getters: {
			shopping_cart: state => state.shopping_cart,
			fedex_quote: state => state.fedex_quote,
			address: state => state.shopping_cart_address,
			allow_continue: state => state.allow_continue,
			national_quote: state => state.national_quote
		},
		actions: {
			setShippingShoppingCart
		}
	},

	computed: {
		render_show_fedex() {
			if (this.shopping_cart.products && this.shopping_cart.products.length) {
				for (let i = 0, p = this.shopping_cart.products; i < p.length; i++) {
					if (p[i].product.fedex_able == '0') {
						return false;
					}
				}
			}

			return true;
		},

		render_fedex_quote() {
			return this.fedex_quote;
		},

		render_national_quote () {
			return this.national_quote;
		},

		render_address () {
			return this.address;
		}
	},

	methods: {
		nextStep(e) {
			e.preventDefault();
			this.has_error = false;
			this.error_msg = null;
			this.validations();

			if (this.has_error) {
				return;
			}

			this.setShippingShoppingCart(this.shipping);
			this.allow_continue[3] = true;
			$('#payment').tab('show');
		},

		validations() {
			if (!this.shipping) {
				this.has_error = true;
				this.error_msg = 'Selecciona un metodo de envio';
			}

			if (this.shipping == 1 && !this.fedex_quote) {
				this.has_error = true;
				this.error_msg = 'Espera a que se calculen los costos de envio.';
			}
		}
	},

	components: {
		Loader
	}
}
</script>


// WEBPACK FOOTER //
// Shopping-cart-shipping.vue?357eb9bc